/* Unseen / Unknown / Unstoppable · conceito (Inverno 2026) */
(function () {
  var root = document.querySelector('[data-uuu]');
  if (!root) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  requestAnimationFrame(function () { root.classList.add('uuu--ready'); });

  /* revelar */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  root.querySelectorAll('[data-rv]').forEach(function (el) { io.observe(el); });

  /* a porta: a rolagem atravessa o corredor e entra na luz; depois da luz, o escuro */
  var door = root.querySelector('[data-uuu-door]');
  if (door && !RM) {
    var cl = function (v) { return Math.max(0, Math.min(1, v)); };
    var dTick = function () {
      var r = door.getBoundingClientRect(), H = window.innerHeight, span = r.height - H;
      if (r.bottom > -50 && r.top < H + 50 && span > 0) {
        var p = cl(-r.top / span);
        var e = cl((p - 0.06) / 0.78); e = e * e * (3 - 2 * e);
        var sc = Math.pow(18, e);
        door.style.setProperty('--s', sc.toFixed(4));
        door.style.setProperty('--l', (0.5 + e * 0.7).toFixed(3));
        door.style.setProperty('--b', Math.min(8, Math.max(0, (sc - 5) * 0.35)).toFixed(2));
        door.style.setProperty('--gl', cl((p - 0.55) / 0.3).toFixed(3));
        door.style.setProperty('--o', cl((p - 0.88) / 0.04).toFixed(3));
      }
      requestAnimationFrame(dTick);
    };
    requestAnimationFrame(dTick);
  }

  /* a lanterna: segue o mouse; parada ou no celular, anda sozinha */
  var dark = root.querySelector('[data-uuu-dark]');
  if (!dark) return;
  var v = dark.querySelector('.uuu__dark-v');
  var lx = 0.5, ly = 0.5, tx = 0.5, ty = 0.5, last = -1e9, on = false;
  if (!touch) {
    dark.addEventListener('pointermove', function (e) {
      var r = dark.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height; last = performance.now();
    });
  }
  new IntersectionObserver(function (es) { on = es[0].isIntersecting; if (on) requestAnimationFrame(tick); }).observe(dark);
  function tick(ts) {
    if (!on) return;
    if (ts - last > 2500) {
      var t = ts / 1000;
      tx = 0.5 + Math.sin(t * 0.35) * 0.33;
      ty = 0.5 + Math.sin(t * 0.53 + 1.3) * 0.27;
    }
    var k = RM ? 1 : 0.06;
    lx += (tx - lx) * k; ly += (ty - ly) * k;
    v.style.setProperty('--x', (lx * 100).toFixed(2) + '%');
    v.style.setProperty('--y', (ly * 100).toFixed(2) + '%');
    requestAnimationFrame(tick);
  }
})();
